import { StyleSheet, View } from "react-native";
import { useSelector } from "react-redux";
import { PdButton, PdButtonLabel } from "src/components/forms/button";
import { PdStack, PdText } from "src/components/layout";
import { PdModal, PdModalCloseButton } from "src/components/overlay";
import { kColors } from "src/kColors";
import { kRoute } from "src/kRoute";
import { kStyleConst } from "src/kStyle";

import { tUseModal, useModal } from "src/providers/OverlayProvider";
import { useAppDispatch } from "src/redux";
import { setCurrentThread } from "src/redux/messages/actions";
import { tModalComponentProps } from "src/redux/modals/types";
import { navigate } from "src/RootNavigation";
import { useIsMobile } from "../ui";

type tModalParams = {
  repId: string;
  brandId: string;
};

const RetailerAccountToMessageModal: React.FC<tModalComponentProps<tModalParams>> = ({ onClose, repId, brandId }) => {
  const dispatch = useAppDispatch();
  const rMessagesThreads = useSelector((state) => state.MessageThreadsReducer.rThreads);
  const isMobile = useIsMobile();

  const navigateToMessage = (id: string) => {
    try {
      const rThreadId = rMessagesThreads.find((thread) => thread.recipient.includes(id));
      if (!rThreadId) throw new Error("An error occurred while attempting to parse the recipient's id.");
      dispatch(setCurrentThread(rThreadId));
      navigate(kRoute.P04);
    } catch (er) {
      dispatch({
        type: "RIBBON",
        message: new Error("Please use the left menu to send a message to the Retailer"),
      });
    }
  };

  const handleOnPressSalesRep = () => {
    navigateToMessage(repId);
    onClose();
  };

  const handleOnPressBrand = () => {
    navigateToMessage(brandId);
    onClose();
  };

  const handleOnClose = () => {
    onClose();
  };

  return (
    <PdModal onClose={handleOnClose}>
      <PdModalCloseButton iconStyle={styles.modalCloseButton} onPress={handleOnClose} />
      <View style={styles.modal}>
        <PdText style={styles.description} variant="body-sm">
          Retailers have the option to either message the sales rep or message the brand. Which would you like to do?
        </PdText>
        <PdStack direction="vertical" layout={[1, 1]} isReversed={isMobile}>
          <PdButton onPress={handleOnPressSalesRep} colorScheme="white" variant="outline">
            <PdButtonLabel>Message Sales Rep</PdButtonLabel>
          </PdButton>
          <PdButton onPress={handleOnPressBrand} colorScheme="white" variant="outline">
            <PdButtonLabel>Message Brand</PdButtonLabel>
          </PdButton>
        </PdStack>
      </View>
    </PdModal>
  );
};

const useRetailerAccountToMessageModal = (): tUseModal<tModalParams> => {
  return useModal(RetailerAccountToMessageModal);
};

export default useRetailerAccountToMessageModal;

const styles = StyleSheet.create({
  description: {
    color: kColors.white,
    marginBottom: 4 * kStyleConst.kSpacing,
    marginTop: 6 * kStyleConst.kSpacing,
    textAlign: "center",
  },
  modal: {
    backgroundColor: kColors.brandPurple,
    maxWidth: 290,
    padding: 6 * kStyleConst.kSpacing,
  },
  modalCloseButton: {
    color: kColors.white,
  },
});
